import FormRow from 'components/FormRow';
import Input from 'components/ui/Input';
import Radio from 'components/ui/Radio';
import { styled } from 'styled-components';
import { CSVFormRowProps } from 'types';

const RadioView = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: 20px;
  row-gap: 10px;
  min-height: 33px;
`;

const SeperatorFormRow = ({ useFormReturn, nodeDataSave }: CSVFormRowProps) => {
  const {
    formState: { errors },
    register,
    watch,
  } = useFormReturn;
  const seperatorIsCustom = watch('seperator') === 'custom';

  return (
    <FormRow label="데이터 구분자" direction="row" labelWidth={120} pos="left">
      <RadioView>
        <Radio
          id="seperator/comma"
          label="쉼표 (,)"
          value={','}
          {...register('seperator', {
            onChange: nodeDataSave,
          })}
        />
        <Radio
          id="seperator/tab"
          label="탭 (\t)"
          value={'\t'}
          {...register('seperator', {
            onChange: nodeDataSave,
          })}
        />
        <Radio
          id="seperator/space"
          label="공백"
          value={' '}
          {...register('seperator', {
            onChange: nodeDataSave,
          })}
        />
        <Radio
          id="seperator/custom"
          label="직접 입력"
          value={'custom'}
          {...register('seperator', {
            onChange: nodeDataSave,
          })}
        />
        {seperatorIsCustom && (
          <Input
            style={{ width: '100px' }}
            error={errors?.seperatorValue?.message}
            {...register('seperatorValue', { required: '선택자를 입력해주세요', onBlur: nodeDataSave })}
          />
        )}
      </RadioView>
    </FormRow>
  );
};

export default SeperatorFormRow;
